document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-site-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        nav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;
        const next = Number(input.value || 1) + Number(button.dataset.step || 0);
        input.value = String(Math.max(0, next));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
});
